import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Color, FontWeight, ValidationBarTheme } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { BarInnerWrapperProps, BarProps, UnderlineButtonProps } from './validationBar.types';

export const BarStyles: { [b in ValidationBarTheme]: FlattenSimpleInterpolation } = {
  [ValidationBarTheme.Error]: css`
    background-color: ${Color.Error500};
    color: ${Color.White};
  `,
  [ValidationBarTheme.Success]: css`
    background-color: ${Color.Success100};
    color: ${Color.Black};
  `,
  [ValidationBarTheme.Information]: css`
    background-color: ${Color.Warning100};
    color: ${Color.Black};
  `,
  [ValidationBarTheme.Gray]: css`
    background-color: ${Color.Gray100};
    color: ${Color.Black};
  `
};

export const Bar: StyledComponent<'div', BarProps> = styled.div<BarProps>`
  background-color: ${Color.Error500};
  font-size: 12px;
  line-height: 16px;
  color: ${Color.White};
  width: 100%;
  ${({ $theme }: BarProps): FlattenSimpleInterpolation => BarStyles[$theme]};
`;

export const BarInnerWrapper: StyledComponent<'div', BarInnerWrapperProps> = styled.div<BarInnerWrapperProps>`
  padding: 12px;
  display: ${({ $renderButtonInline }: BarInnerWrapperProps): string => $renderButtonInline ? 'block' : 'flex'};
  justify-content: space-between;
  align-items: center;
`;

export const UnderlineButton: StyledComponent<typeof MenuPosition, UnderlineButtonProps> = styled(MenuPosition)<UnderlineButtonProps>`
  font-weight: ${FontWeight.Medium};
  display: ${({ $renderButtonInline }: BarInnerWrapperProps): string => $renderButtonInline ? 'inline' : 'block'};
  font-size: 12px;
  line-height: 16px;
  text-decoration-line: underline;
  color: inherit;
  margin-left: 5px;
`;
